import { z } from '@harvestiq/zod';
import {
  GeneratedAlways,
  Selectable,
  Insertable,
  Updateable,
  ColumnType,
} from 'kysely';
import { expectTypeOf } from 'expect-type';
import { DbTimestampGenerated, MakeUndefinedOptional } from '@harvestiq/utils';
import { zTimestamp } from '@harvestiq/zod';

export interface FaqsTable {
  id: GeneratedAlways<string>;
  question: string | null;
  answer: string | null;
  createdAt: DbTimestampGenerated | null;
  updatedAt: DbTimestampGenerated;
  isActive: boolean | null;
}

export type DbFaq = Selectable<FaqsTable>;
export type DbFaqInsert = MakeUndefinedOptional<Insertable<FaqsTable>>;
export type DbFaqUpdate = MakeUndefinedOptional<Updateable<FaqsTable>>;

// Zod schemas
export const dbFaqSchema = z.object({
  id: z.string().uuid(),
  question: z.string().nullable(),
  answer: z.string().nullable(),
  createdAt: z.coerce.date().nullable(),
  updatedAt: z.coerce.date(),
  isActive: z.boolean().nullable(),
});

export const dbFaqInsertSchema = dbFaqSchema
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
  })
  .extend({
    id: z.string().uuid().optional(),
    createdAt: zTimestamp().optional(),
    updatedAt: zTimestamp().optional(),
  });

export const dbFaqUpdateSchema = dbFaqSchema
  .omit({
    id: true,
    createdAt: true,
    updatedAt: true,
  })
  .partial()
  .extend({
    updatedAt: zTimestamp().optional(),
  });

// Type tests
expectTypeOf<DbFaq>().toMatchTypeOf<z.infer<typeof dbFaqSchema>>();
